module.exports = __webpack_public_path__ + "static/media/why-me.b1b86b75.jpg";